import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import logoLight from "@/assets/logo-light.png";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-petrol flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10 flex flex-col items-center">
          <img src={logoLight} alt="Fiorucci Apartments" className="h-28 w-auto" />
          <span className="overline text-gold block mt-3 text-[11px]">Area Admin</span>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-sm p-8 space-y-6">
          <div className="flex items-center gap-2 text-petrol">
            <Lock size={18} strokeWidth={1.5} />
            <span className="font-serif text-2xl">Area riservata</span>
          </div>
          <label className="block">
            <span className="overline text-[10px] text-muted-foreground">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="editorial-input mt-1 text-petrol" data-testid="login-email" />
          </label>
          <label className="block">
            <span className="overline text-[10px] text-muted-foreground">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="editorial-input mt-1 text-petrol" data-testid="login-password" />
          </label>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-petrol text-white py-3.5 rounded-sm hover:bg-[#1A3A41] transition-colors disabled:opacity-60">
            {loading ? "..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
